import { render, staticRenderFns } from "./OSSJSSDK.vue?vue&type=template&id=997d29aa&scoped=true"
import script from "./OSSJSSDK.vue?vue&type=script&lang=js"
export * from "./OSSJSSDK.vue?vue&type=script&lang=js"
import style0 from "./OSSJSSDK.vue?vue&type=style&index=0&id=997d29aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997d29aa",
  null
  
)

export default component.exports